import { useTranslation } from 'react-i18next';
import { ProductFruits } from 'react-product-fruits';

import { useAgentLoggedIn, useAuthStore, useIsLoggedIn } from '@/api/login';
import { useTicker } from '@/theme';

export const ProductFruitsProvider = () => {
  const { userLeadId, email, agent } = useAuthStore();
  const { i18n } = useTranslation();
  const isCustomerLoggedIn = useIsLoggedIn();
  const source = useTicker();
  const isAgentLoggedIn = useAgentLoggedIn();

  const getUserInfo = () => {
    if (isCustomerLoggedIn && userLeadId) {
      return {
        username: userLeadId as string,
        email: email ?? '',
        props: { source },
      };
    }

    if (isAgentLoggedIn) {
      return {
        username: agent?.email as string,
        email: agent?.email as string,
        props: { source },
      };
    }

    return null;
  };

  const userInfo = getUserInfo();

  if (!userInfo) {
    return null;
  }

  return (
    <ProductFruits
      workspaceCode="XYf50aeEt3Tsefqf"
      language={i18n.resolvedLanguage || 'nl'}
      user={userInfo}
    />
  );
};
